import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { AnimatedSection } from './ui/AnimatedSection';
const faqs = [{
  q: '¿Sirve si nunca abrí mi monociclo?',
  a: 'Sí. El Tomo 1 arranca desde cero. No necesitás conocimientos previos.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Por email en menos de 5 minutos. PDF listo para celular, tablet o computadora.'
}, {
  q: '¿Funciona para mi modelo?',
  a: 'Cubre Begode, Kingsong, Inmotion, Sherman y la mayoría de los modelos del mercado argentino.'
}, {
  q: '¿Tiene garantía?',
  a: '7 días completos. Si no cumple lo prometido, te devolvemos el 100% sin preguntas.'
}, {
  q: '¿Necesito herramientas especiales?',
  a: 'No para empezar. El Bono 2 te muestra exactamente qué comprar primero según tu presupuesto.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <AnimatedSection className="py-24 relative" data-id="element-58">
      <div className="container mx-auto px-4 md:px-6" data-id="element-59">
        <div className="max-w-3xl mx-auto" data-id="element-60">
          <div className="text-center mb-12" data-id="element-61">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 flex items-center justify-center gap-3" data-id="element-62">
              <HelpCircle className="w-8 h-8 text-brand-yellow" data-id="element-63" />
              PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-4" data-id="element-64">
            {faqs.map((faq, index) => <div key={index} className="bg-brand-surface border border-brand-border rounded-lg overflow-hidden transition-colors hover:border-zinc-700" data-id="element-65">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-66">
                  <span className="font-bold text-lg text-white" data-id="element-67">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-brand-yellow transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-68" />
                </button>
                <AnimatePresence data-id="element-69">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-70">
                      <div className="px-6 pb-4 text-zinc-400" data-id="element-71">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>
    </AnimatedSection>;
}